import { SET_CURRENT_USER, DELETE_CURRENT_USER } from '../actions/types'
import isEmpty from '../validation/is-empty'

const initialState = {
    isAuthenticated: false,
    user : {}
}

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_USER:
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                user: action.payload
            }
            break;
        case DELETE_CURRENT_USER:
            return {
                ...state,
                isAuthenticated: false,
                user: {}
            }
            break;
    
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/authReducer.js